module.exports = __webpack_public_path__ + "img/img0.05ae6b4a.jpg";